import includes from "lodash/includes";
import { theme } from "../../../theme";
import { NavItem } from "../../../types/Nav";

export const isActive = (currentPath: string, item?: NavItem): boolean => 
  includes(currentPath, item?.title);

export const getBorderColor = (currentPath: string, item: NavItem): string =>
  isActive(currentPath, item) ? theme.colors.accent : theme.colors.primary;

export const getOpacity = (currentPath: string, item: NavItem): string => (isActive(currentPath, item) ? "1" : "0.8");
